import React from 'react';
// helpers
import normalizeSeats from 'helpers/local/normalizeSeats';

const PassengerItemForPrint = ({ data, passengerNumber }) => {
  const { full_name, phone, ticket_price, number_of_tickets, seats, departure_point, arrival_point, comment, ticket_status} = data ?? {};
  const ticketPrice = `${ticket_price}€`;
  const direction = `${departure_point}-${arrival_point}`;
  const normalizedSeats = normalizeSeats(seats);

  return (
    <li className="print-passengers__item print-passenger">
      <span className="print-passenger__number">{passengerNumber}</span>
      <span className="print-passenger__full-name">{full_name}</span>
      <span className="print-passenger__phone">{phone}</span>
      <span className={`print-passenger__ticket-price passenger__ticket-status passenger__ticket-status--${ticket_status}`}>{ticketPrice}</span>
      <span className="print-passenger__number-of-tickets">{number_of_tickets}</span>
      <span className="print-passenger__seats">{normalizedSeats || '-'}</span>
      <span className="print-passenger__direction">{direction}</span>
      <span className="print-passenger__comment" title={comment}>{comment || '-'}</span>
    </li>
  );
};

export default PassengerItemForPrint;
